import { render, staticRenderFns } from "./seguimientos.view.vue?vue&type=template&id=894dde84"
import script from "./seguimientos.view.vue?vue&type=script&lang=js"
export * from "./seguimientos.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports